/*
  Validates if the browser path is a part of strings provided in corePaths
*/
export const doesUrlMatch = (url: string, corePaths: string[]): boolean => {
    return !!corePaths.filter((path) => {
        return url.includes(path)
    }).length
}
